
// Moment date/time formatting
// https://momentjs.com/docs/
import moment from 'moment';


// Utility function to adjust time by window.sessionStorage.getItem("utcOffset")

export const adjustTime = (time: Date | string): Date|string => {
    const adj: string | null = window.sessionStorage.getItem("utcOffset") != "null" ? window.sessionStorage.getItem("utcOffset") : "0";

    if (adj == null || adj == "0" || adj == "undefined") {
        return time;
    }
    else {
        return moment(time).add(parseInt(adj), 'h').toDate();
    }
}

export const adjustTimeToUtc = (time: Date | string): Date | string => {
    const utcOffsetValue: string | null = window.sessionStorage.getItem("utcOffset") !== "null"
        ? window.sessionStorage.getItem("utcOffset")
        : "0";

    if (utcOffsetValue == null || utcOffsetValue === "0" || utcOffsetValue === "undefined") {
        return time;
    }

    return moment(time).subtract(parseInt(utcOffsetValue), 'h').toDate();
};